import {
  getChangeStsList,
  getStsListRepets,
  ToolNumberInput,
} from "@tanyoknits/shared";
import React, { useState } from "react";
import {
  Alert,
  AlertIcon,
  Button,
  Flex,
  Heading,
  Select,
  Text,
  VStack,
} from "@chakra-ui/react";
import { getStringGroupRepeats } from "@tanyoknits/shared";

const DEFAULT_STS_GUAGE = 4.5;
const DEFAULT_ROW_GUAGE = 6.25;
const DEFAULT_ROW_COUNT = 140;

type Result = { stsCount: number; list: string[] };
export default function Calculator() {
  const [stsGuage, setStsGuage] = useState<number>(DEFAULT_STS_GUAGE);
  const [rowGuage, setRowGuage] = useState<number>(DEFAULT_ROW_GUAGE);
  const [rowCount, setRowCount] = useState<number>(DEFAULT_ROW_COUNT);
  const [stsType, setStsType] = useState<number>(2);
  const [result, setResult] = useState<Result | null>(null);

  const updateStsGuage = (n: number): void => {
    setResult(null);
    setStsGuage(n);
  };
  const updateRowGuage = (n: number): void => {
    setResult(null);
    setRowGuage(n);
  };
  const updateRowCount = (n: number): void => {
    setResult(null);
    setRowCount(n);
  };

  const calculate = () => {
    const length = rowCount / rowGuage;
    const rawStsCount = length * stsGuage * 1.04;
    let stsCount = Math.round(rawStsCount);
    if (stsType === 1) {
      if (stsCount % 2 === 0) {
        stsCount = stsCount + 1;
      }
    } else {
      stsCount = Math.round(stsCount / stsType) * stsType;
    }
    // To avoid skipping at the end, substract 1 in both row and sts count,
    const puPoints = getChangeStsList(rowCount - 1, stsCount - 1);
    const instruction = puPoints.map(
      // Add 1 stitch back at the end
      (point, i) =>
        `pu ${
          i < puPoints.length - 1
            ? point - 1
            : `${point} - do not skip at the end`
        }`
    );
    const repeats = getStsListRepets(instruction);
    const grouped = getStringGroupRepeats(repeats);

    setResult({
      stsCount,
      list: grouped.groupRepeats,
    });
  };

  return (
    <>
      <Heading size="md" pt={2} pb={2}>
        Guage
      </Heading>
      <VStack align="left" spacing={-2}>
        <ToolNumberInput
          tail="stitches / inch (2.5 cm)"
          defaultValue={stsGuage.toString()}
          onChange={updateStsGuage}
          step={0.25}
        />
        <ToolNumberInput
          tail="rows / inch (2.5 cm)"
          defaultValue={rowGuage.toString()}
          onChange={updateRowGuage}
          step={0.25}
        />
      </VStack>
      <Flex direction={["column", "row"]} pt={2} pb={2}>
        <Heading size="md" mr={2}>
          Number of rows
        </Heading>
        <Text>(where button band is picked up)</Text>
      </Flex>
      <ToolNumberInput
        tail="rows"
        defaultValue={rowCount.toString()}
        onChange={updateRowCount}
      />
      <Heading size="md" pt={2} pb={2}>
        Number of Pick-up stitches
      </Heading>
      <Select
        width="fit-content"
        defaultValue={stsType}
        onChange={(e) => {
          setResult(null);
          setStsType(+e.target.value);
        }}
      >
        <option value="1">Odd number</option>
        <option value="2">Even number</option>
        <option value="4">Multiple of 4</option>
      </Select>
      <Button onClick={calculate} size="lg" mt={8}>
        Calculate
      </Button>
      {result != null && result.stsCount <= rowCount && (
        <VStack align="left" mt={8}>
          <Heading size="md">Pick up {result.stsCount} stitches</Heading>
          <Alert status="info" width="fit-content">
            <AlertIcon />
            pu X = Pick up X rows, then skip 1 row
          </Alert>
          <div>
            {result.list.map((text, i) => (
              <Text key={i}>{text}</Text>
            ))}
          </div>
        </VStack>
      )}
      {result != null && result.stsCount > rowCount && (
        <Alert status="error" width="fit-content" mt={8}>
          <AlertIcon />
          Adjust the input; pick up stitch count cannot be larger than the row
          count
        </Alert>
      )}
    </>
  );
}
